<template>
	<div ref="root" class="VolumeViewer" :style="layout.style" :class="layout.classes">
		<div class="flex-center">
			<h2 v-if="layers.length == 0">This is a volume viewer</h2>
			<div v-if="layers.length && !show3D" class="VolumeViewer__layer-wrapper">
				<img src="img/viewer-aspect.png" >
				<div class="VolumeViewer__layer" v-for="item in layers" :key="item.key" :style="getLayerStyle(item)">
				</div>
			</div>
			<canvas ref="canvas" class="VolumeViewer__three" v-show="layers.length && show3D"></canvas>
			<div v-if="layers.length && !show3D" class="VolumeViewer__ui-bottom"> frame {{ frame }} </div>
			<div class="VolumeViewer__ui-top-wrapper">
				<drag class="grap-handle-icon" :transfer-data="_self"></drag>
				<div class="VolumeViewer__chip" v-for="item in layers" :key="item.key" @click="removeLayer(item)">{{ item.name }}</div>
			</div>
			<div class="VolumeViewer__ui-right-wrapper" v-if="hasWebGL2">
				<div class="VolumeViewer__ui-button icon-2d" :class="{'is-active': !show3D}" @click="show3D = false"></div>
				<div class="VolumeViewer__ui-button icon-3d" :class="{'is-active': show3D}" @click="show3D = true">
					<div class="VolumeViewer__ui-panel">
						<div class="VolumeViewer__ui-block">
							<h4>min</h4>
							<vue-slider v-model="volumeValueMin" @change="onSliderChange" :min="0" :max="1" :interval="0.001"/>
						</div>
						<div class="VolumeViewer__ui-block">
							<h4>max</h4>
							<vue-slider v-model="volumeValueMax" @change="onSliderChange" :min="0" :max="1" :interval="0.001"/>
						</div>
						<div class="VolumeViewer__ui-block">
							<h4>opacity</h4>
							<vue-slider v-model="volumeValueScale" @change="onSliderChange" :min="0" :max="1" :interval="0.001"/>
						</div>
						<div class="VolumeViewer__ui-block">
							<h4>intensity</h4>
							<vue-slider v-model="volumeValueIntensity" @change="onSliderChange" :min="1" :max="10" :interval="0.001"/>
						</div>
						<div class="VolumeViewer__ui-block">
							<input ref="crossSection" type="checkbox" :id="'cross-section'+inst_id" :name="'cross-section'+inst_id" @change="onSliderChange">
							<label :for="'cross-section'+inst_id">cross-section</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="sass">
.VolumeViewer__ui-block
	display: block
	flex-direction: column
	width: 100%
	padding: 10px 0
	vertical-align: middle

	h4
		margin: 0
		margin-bottom: 10px

	label
		margin: 4px

	input, label
		display: inline-block
		vertical-align: middle
		user-select: none
	

.VolumeViewer
	display: block
	position: absolute
	background: black
	width: 100%
	height: 100%
	margin: 0
	padding: 0

.VolumeViewer__layer-wrapper
	display: inline-block
	position: relative
	margin: 0
	padding: 0
	width: auto
	height: auto

	img
		display: block
		padding: 0
		margin: 0
		background: green
		visibility: hidden
		height: auto
		max-height: 100vh
		width: auto
		max-width: 100%

.half-height
	img
		max-height: 50vh

.VolumeViewer__layer
	display: block
	position: absolute
	left: 0
	right: 0
	top: 0
	bottom: 0
	// background: lime
	background-repeat: no-repeat
	background-size: (9*100%) (8*100%)



.VolumeViewer__ui-bottom
	display: inline-block
	position: absolute
	bottom: 10px
	left: 0
	right: 0
	margin: auto
	font-size: 10px
	color: white
	text-align: center

.VolumeViewer__ui-right-wrapper
	display: inline-flex
	flex-direction: column
	position: absolute
	width: 30px
	height: auto
	top: 50px
	right: 10px
	// background-color: green

.VolumeViewer__ui-panel
	display: inline-flex
	display: none
	position: absolute
	flex-direction: column
	padding: 20px
	width: 300px
	height: auto
	height: 300px
	top: 0
	right: 35px
	background: rgba(100, 100, 100, 0.7)
	border-radius: 30px
	border-top-right-radius: 0
	text-align: right
	color: white


.VolumeViewer__ui-button
	display: block
	position: relative
	cursor: pointer
	background-position: center center
	background-repeat: no-repeat
	background-size: 25px 25px
	width: 35px
	height: 35px
	margin: 10px auto


	&.is-active
		background-color: rgba(128, 128, 128, 0.2)
		// pointer-events: none

		&:hover
			.VolumeViewer__ui-panel
				pointer-events: all
				display: inline-flex

.icon-2d
	background-image: url('../../public/img/2d.svg')

.icon-3d
	background-image: url('../../public/img/3d.svg')



.VolumeViewer__ui-top-wrapper
	display: inline-flex
	position: absolute
	flex-direction: row-reverse
	right: 0
	top: 0

.VolumeViewer__chip
	display: inline-block
	position: relative
	font-size: 10px
	color: white
	padding: 5px 8px
	// padding-left: 20px
	margin: 10px
	margin-left: 0
	border-radius: 40px
	user-select: none
	vertical-align: middle
	cursor: pointer
	line-height: 16px
	
	&:before
		content: '\00d7'
		display: inline-block
		// display: none
		position: relative
		font-size: 16px
		font-weight: 300
		font-family: Arial, sans-serif
		color: white
		margin-right: 5px
		visibility: hidden
		// top: -2px
		vertical-align: middle


	&:hover
		// background: rgba(200, 200, 200, 0.5)

		background: rgba(200, 200, 200, 0.5)
		&:before
			display: inline-block
			visibility: visible

.grap-handle-icon
	display: inline-block
	width: 20px
	height: 20px
	margin: 13px 10px 13px 0px
	background: url('../../public/img/grab-handle-white.svg') no-repeat
	background-size: contain
	cursor: grab

</style>


<script>
import { Drag, Drop } from 'vue-drag-drop';
import { mapState, mapMutations, mapGetters } from 'vuex';
import WebGL from '../utils/WebGL';
import * as THREE from 'three';
import OrbitControls from 'three-orbitcontrols';
import volumeShader from '../shaders/volume-shader';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css';

const HAS_WEBGL2 = WebGL.isWebGL2Available();


// detect available wheel event (MDN)
const WHEEL_EVENT = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
					document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
					"DOMMouseScroll"; // let's assume that remaining browsers are older Firefox
const VOL_WIDTH = 68;
const VOL_HEIGHT = 90;
const VOL_DEPTH = 71;

var _instance_counter = 0;

export default 
{
	name: 'volume-viewer',
	components: 
	{
		Drag,
		VueSlider,
	},
	props: 
	{
		layout: 
		{
			type: Object,
			required: true
		}
	},
	data() 
	{
		return {
			showVolumetric: false,
			showCrossSection: false,
			layers: [],
			webglCtxt: null, // WebGL context
			hasWebGL2: HAS_WEBGL2,
			three: null,
			volumeValueMin: 0,
			volumeValueMax: 1,
			volumeValueScale: 0.3,
			volumeValueIntensity: 1.0,
			_inst_counter: 0,
		};
	},
	computed: 
	{
		...mapGetters(['frame']),

		show3D: 
		{
			get()
			{
				return this.showVolumetric || this.showCrossSection;
			},

			set(value)
			{
				this.showVolumetric = this.showCrossSection = value;
			}
		},

		inst_id()
		{
			return this._inst_counter;
		}

	},
	watch:
	{
		showVolumetric(newVal)
		{
			if (newVal)
			{
				this.initWebGL();
			}
		}
	},

	created() 
	{
		this._inst_counter = _instance_counter++;
	},

	mounted()
	{
		this.$el.addEventListener(WHEEL_EVENT, this.onMouseWheel.bind(this));
	},

	methods: 
	{
		...mapMutations(['setFrame']),

		getLayerStyle(layer)
		{
			var x = this.frame % 9;
			var y = Math.floor(this.frame / 9);
			return {
				'background-position': `${100 * (x/8)}% ${100 * (y/7)}%`,
				'background-image': `url("${layer.url}")`
			}
		},

		setTextures()
		{
			if (!this.three)
				return;

			this.three.textures = [null, null, null];
			for (var i = 0; i < 3 && i < this.layers.length; i++)
			{
				this.three.textures[i] = new THREE.DataTexture3D(	this.layers[i].data, 
																	this.layers[i].texWidth, 
																	this.layers[i].texHeight, 
																	this.layers[i].texDepth );
				this.three.textures[i].format = THREE.RGBAFormat;
				this.three.textures[i].type = THREE.UnsignedByteType;
				this.three.textures[i].minFilter = this.three.textures[i].magFilter = THREE.LinearFilter;
				this.three.textures[i].needsUpdate = true;
			}
			for (var i = 0; i < 3 ; i++)
			{
				this.three.material.uniforms[ "u_volume_tex"+(i+1) ].value = this.three.textures[i] || this.three.textures[0];
			}
			// NOTE: webgl does not seems to accept arrays of samplers
			// this.three.material.uniforms[ "u_volume_tex" ].value = this.three.textures;
			this.three.material.uniforms[ "u_show_vol" ].value = this.three.textures.map(x => !!x);
		},

		initWebGL()
		{
			if (!this.hasWebGL2)
			{
				console.log('WebGL 2 not supported...');
				return;
			}
			if (this.three)
				return;

			this.three = {};
			const ctxt = this.$refs.canvas.getContext( 'webgl2' );
			const renderer = new THREE.WebGLRenderer( { canvas: this.$refs.canvas, context: ctxt } );
			this.three.renderer = renderer;
			renderer.setPixelRatio( window.devicePixelRatio );
			const box = this.$refs.root.getBoundingClientRect();
			renderer.setSize( box.width, box.height );

			const scene = new THREE.Scene();
			this.three.scene = scene;
			// scene.add( new THREE.AxesHelper( 10 ) );

			const camera = new THREE.PerspectiveCamera(75, box.width / box.height, 0.01, 1000)
			camera.position.z = 100;
			this.three.camera = camera;

			const controls = new OrbitControls(camera, renderer.domElement)
			this.three.controls = controls;
			controls.enablePan = false;
			// controls.enableDamping = false;//true;
			// controls.dampingFactor = 0.25;
			// controls.dampingFactor = 1;
			// controls.enableZoom = false;

			controls.addEventListener( 'change', this.render.bind(this) );
			// controls.target.set( 64, 64, 128 );
			// controls.minZoom = 0.5;
			// controls.maxZoom = 4;
			controls.update();

			this.three.textures = [null, null, null];

			const UNI_SCALE = 1;

			var uniforms = THREE.UniformsUtils.clone( volumeShader.uniforms );
			this.three.uniforms = uniforms;
			var material = new THREE.ShaderMaterial( {
				uniforms: uniforms,
				vertexShader: volumeShader.vertexShader,
				fragmentShader: volumeShader.fragmentShader,
				side: THREE.BackSide // The volume shader uses the backface as its "reference point"
			} );
			this.three.material = material;

			var geometry = new THREE.BoxBufferGeometry( 1, 1, 1 );
			var mesh = new THREE.Mesh( geometry, material );
			// mesh.rotation.set(Math.radians(90), 0, 0);
			// mesh.scale.multiplyScalar( UNI_SCALE );
			mesh.updateMatrix()
			scene.add( mesh );

			var bbox = new THREE.BoxHelper( new THREE.Mesh(new THREE.BoxBufferGeometry( VOL_WIDTH/2, VOL_DEPTH/2, VOL_HEIGHT/2 ), new THREE.MeshBasicMaterial() ), 0xffffff );
			this.three.bbox = bbox;
			bbox.visible = false;
			scene.add( bbox );


			uniforms[ "u_volume_dims" ].value.set(	VOL_WIDTH, VOL_DEPTH, VOL_HEIGHT ); // rot X 90degrees
			this.three.material.uniforms[ "u_val_min" ].value = this.volumeValueMin;
			this.three.material.uniforms[ "u_val_max" ].value = this.volumeValueMax;
			this.three.material.uniforms[ "u_val_scale" ].value = this.volumeValueScale*this.volumeValueScale*this.volumeValueScale*this.volumeValueScale*this.volumeValueScale;;
			this.three.material.uniforms[ "u_val_intensity" ].value = this.volumeValueIntensity;
			this.three.material.uniforms[ "u_dt_scale" ].value = 1;
			this.three.material.uniforms[ "u_cross_section" ].value = false;

			this.setTextures();

			this.three.mesh = mesh;

			this.$nextTick( ()=>{
				console.log(this.three.material.uniforms);
				this.render();
			} );
		},

		onResize()
		{
			if (!this.three)	return;
			const box = this.$refs.root.getBoundingClientRect();
			this.three.camera.aspect = box.width / box.height;
			this.three.camera.updateProjectionMatrix();
			this.three.renderer.setSize( box.width, box.height );
			this.render();
		},

		render()
		{
			if (!this.three)	return;
			this.three.renderer.render( this.three.scene, this.three.camera );
		},

		onSliderChange()
		{
			if (!this.three)	return;

			this.three.material.uniforms['u_val_min'].value = Math.min(this.volumeValueMin, this.volumeValueMax);
			this.three.material.uniforms['u_val_max'].value = Math.max(this.volumeValueMin, this.volumeValueMax);
			this.three.material.uniforms['u_val_scale'].value = this.volumeValueScale*this.volumeValueScale*this.volumeValueScale*this.volumeValueScale*this.volumeValueScale;
			this.three.material.uniforms['u_val_intensity'].value = this.volumeValueIntensity;
			// console.log(`${this.volumeValueMin} ${this.volumeValueMax} ${this.volumeValueScale}`);

			this.three.material.uniforms[ "u_cross_section" ].value = this.$refs.crossSection.checked;
			this.three.bbox.visible = this.$refs.crossSection.checked;

			this.render();
		},

		onMouseWheel(evt)
		{
			var mode = evt.deltaMode || 1;
			var wheelDelta = 0;

			// console.log('onMouseWheel ', evt);
			if ( WHEEL_EVENT == "mousewheel" ) 
			{
				wheelDelta = - 1/40 * evt.wheelDelta;
			} 
			else 
			{
				wheelDelta = evt.deltaY || evt.detail;
			}

			// console.log('wheel delta ', wheelDelta);
			if (mode == 0) // The delta values are specified in pixels.
				wheelDelta = Math.round(-wheelDelta / 200);
			if (mode == 1) // The delta values are specified in lines.
				wheelDelta = Math.sign(-wheelDelta);
			if (mode == 2) // The delta values are specified in pages.
				wheelDelta = Math.round(-wheelDelta / window.innerHeight);

			this.setFrame(this.frame + wheelDelta);
		},

		addLayer(tilesheet)
		{
			if (!tilesheet) return;
			this.layers.push( {
					name: tilesheet.name,
					url: tilesheet.url,
					data: tilesheet.data,
					texWidth: tilesheet.texWidth,
					texHeight: tilesheet.texHeight,
					texDepth: tilesheet.texDepth,
					key: (new Date()).getTime()
				} );

			if (this.layers.length < 4 && this.three)
			{
				this.setTextures();
				this.render();
			}
		},

		removeLayer(item)
		{
			var idx = this.layers.indexOf(item);
			if (idx > -1)
				this.layers.splice(idx, 1);

			if (this.layers.length < 4 && this.three)
			{
				this.setTextures();
				this.render();
			}

			if (this.layers.length == 0)
				this.$emit('removeViewer', this);
		},

		onDragOver(event)
		{
			console.log('onDragOver: ', event);
		},

		onDrop(event)
		{
			console.log('onDrop: ', event);
		}
	}
}
</script>
